/**
 * Created by alex.y on 10/13/2017.
 */
export enum OrderItemOptions{
    IsPassVehicle = 1,
    IsTrucks = 2,
    IsAC = 4,
    IsVehicleParts = 8,
    IsLessOrEqualFifteenYrs = 16,
    UsedEquipment = 32,
    isTrailerOnly = 64
}


// WEBPACK FOOTER //
// ./app/objects/orders/orderItemOptions.ts